import React, { useState } from 'react';
import { colors } from '../theme';

export default function OrgSetupModal({ onJoin, onSkip }) {
  const [orgName, setOrgName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = orgName.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError('');
    try {
      await onJoin(trimmed);
    } catch (err) {
      setError(err.message || 'Failed to join company.');
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: 'rgba(0,0,0,0.72)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        background: '#111b16',
        border: '1px solid rgba(70,187,137,0.2)',
        borderRadius: '14px',
        padding: '2rem',
        maxWidth: '460px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem'
      }}>
        <img
          src="/wave-configurator-app/inspiration/Horizontal logo SVG/SVG/North-Invent-neg-green-Long.svg"
          alt="North Invent"
          style={{ height: '26px', width: 'auto' }}
        />
        <div>
          <h2 style={{ color: colors.textStrong, margin: '0 0 0.4rem', fontSize: '1.3rem' }}>
            Set up your company
          </h2>
          <p style={{ color: colors.textMuted, margin: 0, fontSize: '0.9rem', lineHeight: 1.6 }}>
            Create your company to claim devices and unlock an extra month of warranty coverage.
            If teammates sign up with the same company name, they'll automatically join the same group.
            You can skip this and set it up later.
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <input
            className="ni-input"
            type="text"
            placeholder="e.g. Acme Agriculture AS"
            value={orgName}
            onChange={e => setOrgName(e.target.value)}
            maxLength={120}
            autoFocus
            style={{ fontSize: '1rem' }}
          />
          {error && <p style={{ color: '#f87171', margin: 0, fontSize: '0.85rem' }}>{error}</p>}
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="ni-button ni-button--ghost"
              onClick={onSkip}
              disabled={submitting}
            >
              Skip for now
            </button>
            <button
              type="submit"
              className="ni-button ni-button--primary"
              disabled={!orgName.trim() || submitting}
            >
              {submitting ? 'Saving…' : 'Create company'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
